export default __webpack_public_path__ + "static/media/logo-embarq.913d55b5.svg";